import { GameClient, GameClientLoadingState } from '../../gameClient/gameClient';
import { PreloaderScreen } from '../../gameClient/webgl/preloaderScreen';
import { ClientEvents } from '../../constants/clientEvents';
import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { DeathTimer } from '../../gameClient/webgl/deathTimer';
import { PingMeIfAliveCommand } from '../../gameClient/clientCommands/pingMeIfAliveCommand';
import { NewGameVideoPreloader } from '../../gameClient/webgl/newGameVideoPreloader';
import { initWebChat } from '../../supportTicket/supportWindow';
import { container } from '../../utils/container/container';
import { ServiceIds } from '../../utils/container/service-ids';
import { FeatureFlagsLoader } from '@scorewarrior/rubens_web_lib';
import { FlagNames } from '../../utils/feature-flags/flag-names';


export class ShowClientHandler {
    public handle(): void {
        const clientLoadingFinished = GameClient.getInstance().getLoadingState() === GameClientLoadingState.LOADED;

        if (NewGameVideoPreloader.getIsVideoInProgress() === true && clientLoadingFinished) {
            return;
        }

        NewGameVideoPreloader.forceClose();
        PreloaderScreen.getInstance().hide();
        PreloaderScreen.getInstance().removePreloader();
        GameClient.show();
        this.setupDeathTimer();

        initWebChat();
    }

    private setupDeathTimer() {
        const ffLoader = container.get<FeatureFlagsLoader>(ServiceIds.FEATURE_FLAG_LOADER);
        const deathTimerEnabled = ffLoader.get(FlagNames.CLIENT_DEATH_TIMER_ENABLED).isOn();
        if (!deathTimerEnabled && window.app.config.death_timer) {
            console.warn('death timer disabled');
            return;
        }
        ClientEventEmitter.fireEvent(ClientEvents.WEBGL_FINISH_LOADING);
        DeathTimer.init();
        GameClient.getInstance().sendCommand(new PingMeIfAliveCommand());

        setInterval(() => {
            GameClient.getInstance().sendCommand(new PingMeIfAliveCommand());
        }, 10000);
    }
}
